import store from '../store/Store';

let featureFlags: Map<string, boolean> | undefined = undefined;
export default function getFeatureFlags() {
    return (featureFlags ??= store(null).featureFlags);
}
